import React from 'react'
import styles from './style.module.scss'
import { getImgURL } from '@shared-submodule/utils'
import MyImage from '@shared/components/myImage'
import CustomLink from '@shared/components/customLink'
import useWindowSize from '@shared/hooks/windowSize'

const InterestingReads = () => {
  const data = [
    {
      oSeo: {
        sSlug: 'https://www.oneturf.news/olympics/the-legacy-of-neeraj-chopra-the-journey-of-indias-golden-boy-from-tokyo-to-the-2024-paris-olympics'
      },
      oImg: {
        sUrl: 'media/attachments1721311163173_Untitled-design.png'
      },
      sSrtTitle: 'The Legacy of Neeraj Chopra - The Journey Of India’s Golden Boy From Tokyo To The 2024 Paris Olympics'
    },
    {
      oSeo: {
        sSlug: 'https://www.oneturf.news/olympics/paris-olympics-2024-top-contenders-who-will-lead-indias-medal-hopes-at-the-olympic-games'
      },
      oImg: {
        sUrl: 'media/attachments1721299183471_blog.jpeg'
      },
      sSrtTitle: 'Paris Olympics 2024: Top Contenders Who Will Lead Indias Medal Hopes At The Olympic Games'
    },
    {
      oSeo: {
        sSlug: 'https://www.oneturf.news/olympics/india-in-olympics-total-medals-earned-in-the-olympics-history-and-the-contingent-for-the-2024-paris-olympics'
      },
      oImg: {
        sUrl: 'media/attachments1721374707423_blog-(1).jpeg'
      },
      sSrtTitle: 'India In Olympics: Total Medals Earned In The Olympics History And The Contingent For The 2024 Paris Olympics'
    },
    {
      oSeo: {
        sSlug: 'https://www.oneturf.news/olympics/2024-paris-olympics-a-look-at-the-shocking-absence-of-notable-indian-names-from-this-edition'
      },
      oImg: {
        sUrl: 'media/attachments1721392149376_Untitled-design-(2).png'
      },
      sSrtTitle: '2024 Paris Olympics: A Look At The Shocking Absence Of Notable Indian Names From This Edition'
    }
  ]

  const [width] = useWindowSize()
  return (
    width < 480 ? null : (
      <div className={`container ${styles.highlight} px-0`}>
      <div className='widget-title  d-flex justify-content-between align-items-center'>
        <h3 className='small-head d-flex align-items-center  mb-0'>
          <span>Interesting Reads</span>
        </h3>
      </div>
      <div className={`container ${styles.interesting_cards} px-0`}>
        {data?.map((a, i) => {
          return (
            <CustomLink key={i} href={a?.oSeo?.sSlug}>
              <div className={`cursor-pointer ${styles.cards}`}>
                <div className={`${styles.cardsImage} d-block block-img`}>
                  <MyImage src={getImgURL(a?.oImg?.sUrl)} layout='responsive' alt='Read 1' width={300} height={200} />
                </div>
                {width > 992 ? <p>{a.sSrtTitle.length > 70 ? `${a.sSrtTitle.slice(0, 70)}...` : a?.sSrtTitle }</p> : <p>{a.sSrtTitle.length > 55 ? `${a.sSrtTitle.slice(0, 55)}...` : a?.sSrtTitle }</p> }

              </div>
            </CustomLink>
          )
        })}
      </div>
    </div>
    )
  )
}

export default InterestingReads
